import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { injectIntl } from 'react-intl'
import FormattedMessage from '../../components/FormattedMessage/FormattedMessage'
import './NotFound.scss'

class NotFound extends React.Component {
  render() {
    const { intl } = this.props
    const label = intl.formatMessage({ id: 'error.global.404' })

    return (
      <div>
        <Helmet>
          <title>{label}</title>
        </Helmet>
        <div className="container text-justify" aria-labelledby="errorTitle">
          <h1 className="error-code" id="errorTitle" tabIndex={-1}>
            <FormattedMessage id="error.global.oops" />
          </h1>
          <h2>
            <FormattedMessage id="error.global.pageNotFound" />
          </h2>
          <p>
            <FormattedMessage id="error.global.pageNotFound" />
            <br />
            <Link
              className="redirect"
              to="/"
              aria-label={`${intl.formatMessage({
                id: 'error.global.clickHere',
              })} ${intl.formatMessage({ id: 'error.global.toReturnHome' })}`}
            >
              <i>
                <FormattedMessage id="error.global.clickHere" />{' '}
              </i>
            </Link>
            <FormattedMessage id="error.global.toReturnHome" />
          </p>
        </div>
      </div>
    )
  }
}

export default injectIntl(NotFound)
